import WebLog from './WebLog';
import CompatibilityChecker from './utils/CompatibilityChecker';

// 지원하지 않는 브라우저에서 동작할 경우 WebLog 의 function 을 모두 empty function 으로 설정한다.
if (!CompatibilityChecker.isSupported()) {
  let propName: string;

  const emptyFunction = function(){ /* empty function */ };

  for (propName in WebLog.prototype) {
    if (typeof WebLog.prototype[propName as keyof typeof WebLog.prototype] === 'function') {
      // @ts-expect-error replacing all functions with empty functions
      WebLog.prototype[propName as keyof typeof WebLog.prototype] = emptyFunction;
    }
  }
}

export default new WebLog();
